$(function() {
    $('.slideshow').each(function() {
        if ($(this).find('img').length > 1) {
            $(this).owlCarousel({
                items: 1,
                loop: true,
                nav: false,
                dots: false,
                autoplay: true,
                animateIn: 'fadeIn',
                animateOut: 'fadeOut',
                autoplayTimeout: 2000,
                autoplaySpeed: 1000,
                autoplayHoverPause: true,
                mouseDrag: false, // Disable drag with mouse
                touchDrag: false, // Disable drag on touch device
                onInitialized: function() {
                    $(this.$element[0]).attr('tabindex', -1).removeAttr('role');
                },
            });
        }
    });
});

